import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { SubcomponentVerificationModel } from '../../../models/dictionaries/subcomponents-verification.model';

declare var $: any;


@Component({
  selector: 'app-subcomponents-verification-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addSubcomponentForVerificationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="templateSubcomponent.name" #ctrl="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="templateSubcomponent.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl.invalid" (click)="saveNewSubcomponentForVerification()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedSubcomponent.name" #ctrl2="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedSubcomponent.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl2.invalid" (click)="editSubcomponentForVerification()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this subcomponent for verification?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteSubcomponentForVerification(editedSubcomponent)">Delete</button>
            </div>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addSubcomponentForVerificationModal">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let subcomponent of subcomponentVerificationGridData, let row_no = index">
        <td>{{subcomponent.name}}</td>
        <td>{{subcomponent.description}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(subcomponent, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(subcomponent, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class SubcomponentsVerificationGridComponent implements OnInit {
  isSubcomponentsVerificationHidden = true;
  subcomponentVerificationGridData: SubcomponentVerificationModel[];
  templateSubcomponent = new SubcomponentVerificationModel();
  editedSubcomponent = new SubcomponentVerificationModel();
  rowNumber: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteSubcomponentForVerificationSubject.subscribe( (value) => {
      this.subcomponentVerificationGridData = this.subcomponentVerificationGridData.filter(x => x._id !== value);
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllSubcomponentsForVerification().subscribe((response) => {
      this.subcomponentVerificationGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isSubcomponentsVerificationHidden = !this.isSubcomponentsVerificationHidden;
  }

  saveNewSubcomponentForVerification() {
    this.mainPageService.addNewSubcomponentForVerificationIntoDb(JSON.stringify(this.templateSubcomponent)).subscribe((response) => {
      this.templateSubcomponent._id = response;
      this.subcomponentVerificationGridData
  .push(this.templateSubcomponent);
      this.templateSubcomponent = new SubcomponentVerificationModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedSubcomponent = {
      ...element,
    };
    this.rowNumber = row;
  }

  editSubcomponentForVerification() {
    console.log(this.subcomponentVerificationGridData[this.rowNumber]);
    Object.assign(this.subcomponentVerificationGridData[this.rowNumber], this.editedSubcomponent);
    this.mainPageService.updateSubcomponentForVerificationInDb(JSON.stringify(this.editedSubcomponent)).subscribe(() => { });
  }

  deleteSubcomponentForVerification(element) {
    this.mainPageService.removeSubcomponentForVerification(element._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteSubcomponentForVerificationSubject.next(element._id);
  }
}
